<template>
  <div class="container-fluid mt-3">
    <h3>Willkommen beim Trendsoft Connector</h3>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {
  }
}
</script>
